import { ChartType } from '@dbl/core/chart';

import type {
  IAnalysisPieChartResponseDto,
  IAnalysisPieChartResultVo,
  TAnalysisPieChartSumDataDto,
  TAnalysisPieChartSumDataVo,
} from '../types';

import {
  isNonEmptyWireArray,
  normalizeTableDataList,
  pickChartDisplayMeta,
} from './common';

/** Pie · `chart_sum_data` wire 是否无有效数据。 */
function isPieChartWireNoData(
  value: TAnalysisPieChartSumDataDto | null | undefined,
): boolean {
  if (!isNonEmptyWireArray(value)) {
    return true;
  }

  return value.every(item => item == null);
}

/**
 * Pie · `chart_sum_data` 透传；过滤 `null` 块（wire 空态可能为 `[null]`）。
 */
function normalizePieChartSumData(
  value: TAnalysisPieChartSumDataDto | null | undefined,
): TAnalysisPieChartSumDataVo {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter(
    item => item !== null && typeof item === 'object',
  ) as TAnalysisPieChartSumDataVo;
}

export function transformPieChartResponseDtoToVo(
  dto: IAnalysisPieChartResponseDto,
): IAnalysisPieChartResultVo {
  const { chart_sum_data: pieChartDataWire, table_data: tableDataWire } = dto;
  const isNoData = isPieChartWireNoData(pieChartDataWire);

  return {
    ...pickChartDisplayMeta(dto),
    chartType: ChartType.Pie,
    isNoData,
    ...(isNoData
      ? {}
      : {
          pieChartData: normalizePieChartSumData(pieChartDataWire),
          tableData: normalizeTableDataList(tableDataWire),
        }),
  };
}
